var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("sc-page-base", { attrs: { title: _vm.title } }, [
    _c(
      "div",
      { staticClass: "box" },
      [
        _c(
          "div",
          { staticClass: "has-text-right page-analytic-detail" },
          [
            _c(
              "sc-button",
              {
                staticClass: "is-primary",
                attrs: { loading: _vm.loadingExports },
                on: { click: _vm.exportExcel }
              },
              [
                _c("span", [_vm._v("Exportar para Excel")]),
                _vm._v(" "),
                _c("sc-icon", {
                  attrs: { icon: "file-excel", size: "is-small" }
                })
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "sc-table",
          {
            attrs: {
              data: _vm.detail,
              loading: _vm.loading,
              "default-sort": "invoice",
              paginated: ""
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _c(
                      "sc-table-column",
                      {
                        attrs: {
                          field: "invoice",
                          label: "Nota Fiscal",
                          sortable: ""
                        }
                      },
                      [
                        _vm._v(
                          "\n          " + _vm._s(row.invoice) + "\n        "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "sc-table-column",
                      {
                        attrs: {
                          field: "invoice_serie",
                          label: "Série NF",
                          sortable: ""
                        }
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(row.invoice_serie) +
                            "\n        "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "sc-table-column",
                      {
                        attrs: {
                          field: "order_number",
                          label: "Pedido de Entrega"
                        }
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(row.order_number) +
                            "\n        "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "sc-table-column",
                      {
                        attrs: {
                          field: "logistic_provider_name",
                          label: "Transportadora"
                        }
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(row.logistic_provider_name) +
                            "\n        "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "sc-table-column",
                      {
                        attrs: {
                          field: "warehouse",
                          label: "Centro de Distribuição"
                        }
                      },
                      [
                        _vm._v(
                          "\n          " + _vm._s(row.warehouse) + "\n        "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "sc-table-column",
                      {
                        attrs: {
                          field: "dispatch_date",
                          label: "Data Despacho"
                        }
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm._f("date")(row.dispatch_date, "DD/MM/YYYY")
                            ) +
                            "\n        "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "sc-table-column",
                      {
                        attrs: {
                          field: "tms_freight_value",
                          label: "Valor Frete TMS"
                        }
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm._f("currency")(row.tms_freight_value)) +
                            "\n        "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "sc-table-column",
                      {
                        attrs: {
                          field: "logistic_provider_freight_value",
                          label: "Valor Frete Transportadora"
                        }
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm._f("currency")(
                                row.logistic_provider_freight_value
                              )
                            ) +
                            "\n        "
                        )
                      ]
                    )
                  ]
                }
              }
            ])
          },
          [
            _c(
              "template",
              { attrs: { slot: "bottom-left" }, slot: "bottom-left" },
              [
                _c("sc-table-per-page", {
                  attrs: { pageListNumber: _vm.pagesList },
                  model: {
                    value: _vm.pagination.limit,
                    callback: function($$v) {
                      _vm.$set(_vm.pagination, "limit", $$v)
                    },
                    expression: "pagination.limit"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "template",
              { attrs: { slot: "empty" }, slot: "empty" },
              [_c("sc-table-empty")],
              1
            )
          ],
          2
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8141b4f0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8141b4f0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-recon/features/analytics-detail/PageAnalyticsDetail.vue
// module id = null
// module chunks = 